import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Drawer, IconButton, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

export default function TemporaryDrawer(props) {
  const { history, isAdmin } = props;
  const classes = useStyles();

  const invullList = [
    {
      text: "Modellen",
      onClick: () => history.push("/Form/Modellen/1"),
    },
    {
      text: "Modellen die ik nog niet heb!",
      onClick: () => history.push("/Form/Modellen/Die/Ik/Niet/Heb/1"),
    },
    {
      text: "Video's",
      onClick: () => history.push("/Form/Video's/1"),
    },
    {
      text: "Pins",
      onClick: () => history.push("/Form/Pins/1"),
    },
  ];

  const overigeList = [
    {
      text: "Totaal overzicht",
      onClick: () => history.push("/Statistical Overview"),
    },
    {
      text: "Dubbele modellen",
      onClick: () => history.push("/Duplicates"),
    },
  ];

  const treinenList = [
    {
      text: "Overzicht",
      onClick: () => history.push("/Treinen"),
    },
  ];

  const [state, setState] = React.useState({ left: false });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {isAdmin ? (
          <React.Fragment>
            <ListItem>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    type="body2"
                    style={{ color: "black", fontWeight: "bold" }}
                  >
                    Invullijsten
                  </Typography>
                }
              />
            </ListItem>
            <Divider />

            {invullList.map((item) => {
              const { text, onClick } = item;
              return (
                <ListItem button key={text} onClick={onClick}>
                  {/*icon && <ListItemIcon>{icon}</ListItemIcon>*/}
                  <ListItemText primary={text} />
                </ListItem>
              );
            })}
          </React.Fragment>
        ) : (
          ""
        )}
        <Divider />
        <ListItem>
          <ListItemText
            disableTypography
            primary={
              <Typography
                type="body2"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Model treinen
              </Typography>
            }
          />
        </ListItem>
        <Divider />
        {treinenList.map((item) => {
          const { text, onClick } = item;
          return (
            <ListItem button key={text} onClick={onClick}>
              {/*icon && <ListItemIcon>{icon}</ListItemIcon>*/}
              <ListItemText primary={text} />
            </ListItem>
          );
        })}

        <Divider />
        <ListItem>
          <ListItemText
            disableTypography
            primary={
              <Typography
                type="body2"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Overige
              </Typography>
            }
          />
        </ListItem>
        <Divider />
        {overigeList.map((item) => {
          const { text, onClick } = item;
          return (
            <ListItem button key={text} onClick={onClick}>
              {/*icon && <ListItemIcon>{icon}</ListItemIcon>*/}
              <ListItemText primary={text} />
            </ListItem>
          );
        })}
      </List>
    </div>
  );

  return (
    <React.Fragment key={"left"}>
      <IconButton
        edge="start"
        className={classes.menuButton}
        color="inherit"
        aria-label="menu"
        onClick={toggleDrawer("left", true)}
      >
        <MenuIcon />
      </IconButton>
      <Drawer
        anchor={"left"}
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        {list("left")}
      </Drawer>
    </React.Fragment>
  );
}
